import { EnvironmentInjector, inject, Injectable, Injector, runInInjectionContext } from "@angular/core";
import { Actions, createEffect, FunctionalEffect, ofType } from "@ngrx/effects";
import { map } from "rxjs";
import { timerActions } from "./timer.actions";
import { TimerBlueprint } from "../timer";
import { BlueprintEffectClass } from "../../../instance-service/effect-class-blueprint";
import { InstanceService } from "../../../instance-service/instance.service";

@Injectable()
export class TimerEffects extends BlueprintEffectClass<TimerBlueprint> {
  override actions$ = inject(Actions);
  instanceService = inject(InstanceService);
  override actions: ReturnType<typeof timerActions>;
  override instance: TimerBlueprint


  tickTest = createEffect(() => {
    return this.actions$.pipe(
      ofType(this.actions.tick),
      map((action) => {

        let test = this.instance
        // console.log("Timer EFFECT Descrement!!!!", JSON.stringify(action))
        console.log("Timer EFFECT ", test.id, " ", action.type)
        this.instance.dispatch(this.instance.actions$.decrementMinutes())
      }),
    )}, { functional: true, dispatch: false },
  )
  // rewindTestTest = createEffect(() => {
  //   return this.actions$.pipe(
  //     ofType(this.actions.rewindTarget),
  //     map((action) => {
  //       console.log("Timer EFFECT REWIND!!!", JSON.stringify(action))
  //     }),
  //   )}, { functional: true, dispatch: false },
  // )
}
